import { ProductDTO } from '../product-dto/product-dto';

/**
 * DTO response for family of products listing from API
 * @param {number} id number
 * @param {string} name string
 * @param {string} description string
 * @param {ProductDTO[]} products string
 * @param {number} vips boolean
 *
 */
export class FamilyDTO {
  /**
   * @constructor
   */
  constructor(
    public id: number,
    public name: string,
    public products: ProductDTO[],
    public vipQuantity: number
  ) {}

  /**
   * Factory method for familyList mock
   * @return {FamilyDTO[]} FamilyDTO[]
   */
  static MockFamilies(): FamilyDTO[] {
    return [
      {
        id: 1,
        name: 'S',
        products: [],
        vipQuantity: 0,
      },
      {
        id: 2,
        name: 'F',
        products: [],
        vipQuantity: 0,
      },
      {
        id: 3,
        name: 'G',
        products: [],
        vipQuantity: 0,
      },
    ];
  }
}
